import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { useSessionContext } from '@/contexts/SessionContext';
export var ProtectedRoute = function (_a) {
    var children = _a.children;
    var token = useSessionContext().token;
    var location = useLocation();
    if (!token) {
        return _jsx(Navigate, { to: "/login", state: { from: location }, replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
